import React from 'react';
import { Typography, Grid, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import KeyBoard from '../../../../../assets/img/teclado.jpg'

export default function Description() {
  return (
    <>
     <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <img
              src={KeyBoard}
              alt="Descripción de la imagen"
              style={{ maxWidth: '500px', height: '300px', marginTop: '20px' }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body1" align="left">
              <p style={{fontSize: '15px'}}>El servicio de Reparación a domicilio es el complemento perfecto para el servicio de Asistencia Tecnológica Online, ya que da una respuesta completa a las necesidades del usuario ante las incidencias que se produzcan en sus equipos informáticos.</p>
              <p style={{fontSize: '15px'}}>Tras un primer diagnóstico online, si se detecta la necesidad de asistencia presencial o in situ, un técnico especializado en la materia se desplazará al domicilio del usuario para identificar y resolver aquellas incidencias que no se hayan podido solucionar de forma remota.</p>
              <p style={{fontSize: '15px'}}>Una amplia red de técnicos certificados en las últimas soluciones tecnológicas, hace que este servicio sea eficaz, útil y muy satisfactorio para nuestros clientes.</p>
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Typography variant="body1" align="left">
              <h4>Como acceder</h4>
              <ol style={{paddingInlineStart: '20px'}}>
                <li>Para comenzar a utilizar este servicio, en primer lugar debe registrarse; el registro sólo debe realizarse la primera vez que acceda a alguno de los servicios contenidos en la solución.</li>
                <li>Una vez que se haya registrado, podrá acceder a todos los servicios. Seleccione en Acceda al servicio y comience a disfrutar del mismo.</li>
              </ol>
              <Box
                component={Link}
                to="/"
                sx={{
                  display: 'inline-flex', // Asegura que los íconos y el texto se alineen correctamente
                  alignItems: 'center', // Centra el contenido del enlace verticalmente
                  bgcolor: 'red',
                  '&:hover': {
                    bgcolor: 'darkred',
                  },
                  color: 'white', // Establece el color del texto e ícono a blanco
                  textDecoration: 'none', // Remueve el subrayado del enlace
                  width: '50%', // O ajusta según sea necesario
                  justifyContent: 'center', // Centra el contenido horizontalmente si es necesario
                  padding: '6px 16px', // Ajusta el padding para igualar al del Button, si es necesario
                }}
              >
                Accede al sitio
              </Box>

            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Typography variant="body1" align="left">
              <h4>Cómo usar</h4>
              <ol style={{paddingInlineStart: '20px'}}>
                <li>Una vez que haya accedido al servicio, podrá iniciar una conversación vía chat con nuestros técnicos en la sección “Consulta a un experto". A continuación seleccione “conectar” e iniciará una conversación con un técnico.</li>
                <li>Si por el contrario desea contactar con un técnico en relación a una consulta abierta, podrá reanudar la conversación en la sección “Historial”.</li>
                <li>A continuación, describa el motivo de su consulta a través de chat de la aplicación. En caso de que la incidencia no pueda resolverse de forma remota, procederemos a enviar un técnico a su domicilio.</li>
                <li>Nuestros gestores de servicios contactarán con usted por teléfono, para concertar la cita para la prestación del servicio in situ.</li>
              </ol>
            </Typography>
          </Grid>
        </Grid>
        </>
  );
}